export default "__VITE_ASSET__QQWhwxio__"